module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("7Qdyn"))).then(() => parcelRequire('cTdvD'));